module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Tyler Edwards-2c75c1b7f65b2278787ef850b345611d.jpg";